import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { ExchangeRatesRes } from '@/types/api/deposit-payment/exchange-rates.d';

export const getExchangeRates = () =>
  get<ExchangeRatesRes>('/wallet/v1/exchange_rates');

export const useGetExchangeRates = createApiQuery(
  getExchangeRates,
  (params) => ['exchange-rates', params]
);